import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { AdminUserInterface } from "./AdminUser";
import HelperService from "../../utility/HelperService";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import ChangePasswordBlade from "./ChangePasswordBlade";
import { useForm } from "react-hook-form";
type FormData = {
  fullName: string;
  username: string;
  email: string;
  password?: string;
  confirmPassword?: string;
  role: string; // 👈 IMPORTANT (sirf id)
};

interface PropData {
  show: boolean;
  handleClose: () => void;
  data: AdminUserInterface | null;
}
const AddAdminUser = (props: PropData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [bladeTitle, setBladeTitle] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [selectedUser, setSelectedUser] = useState<AdminUserInterface | null>(
    null
  );
  const [roles, setRoles] = useState([]);

  const [isPasswordBladeOpen, setPasswordBladeOpen] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (props.data) {
      setBladeTitle("Edit Admin User");
      reset({
      ...props.data,
      role: props.data.role?._id || "", // 👈 FIX
    });
    } else {
      reset({});
      setBladeTitle("Add Admin User");
      setShowNewPassword(false);
    }
    roleList();
  }, [props.show]);
  const roleList = () => {
    setLoading(true);
    WebService.getAPI({
      action: `admin-user/roles-list`,
      body: null,
    })
      .then((res: any) => {
        console.log("roles", res);
        setLoading(false);
        setRoles(res.data);
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  const onSubmit = (requestBody: FormData) => {
    setLoading(true);
    WebService[props.data?._id ? "putAPI" : "postAPI"]({
      action: props.data?._id
        ? `admin-user/user/update`
        : `admin-user/user/create`,
      body: requestBody,
      id: "saveUserButton",
    })
      .then((res: any) => {
        toast.success(
          props.data?._id
            ? "Admin User Updated Successfully."
            : "Admin User Created Successfully."
        );
        setLoading(false);
        setShowConfirmPassword(false);
        handleClose();
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message ||
          "Something went wrong. Please try again later."
        );
        setLoading(false);
      });
  };

  const openPasswordBlade = () => {
    if (props.data) {
      setSelectedUser(props.data);
      onCloseModal();
      setPasswordBladeOpen(true);
    }
  };

  const handleClose = props.handleClose;
  const show = props.show;

  const onCloseModal = (e?: any) => {
    reset({});
    props.handleClose();
    setShowNewPassword(false);
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          onCloseModal();
        }}
        placement="end"
        className="offcanvas-large"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Name */}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Full Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter full name"
                {...register("fullName", { required: "Please enter full name" })}
              />
              {errors.fullName && (
                <div className="error-message">{errors.fullName.message}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                User Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter user name"
                {...register("username", {
                  required: "Please enter user name",
                })}
              />
              {errors.username && (
                <div className="error-message">{errors.username.message}</div>
              )}
            </Form.Group>

            <div className="form-group">
              <Form.Label className="label">
                Email <span className="text-danger">*</span>
              </Form.Label>
              <input
                className="form-control"
                placeholder="Enter Email"
                type="text"
                readOnly={!!props.data?._id}
                style={props.data?._id ? { backgroundColor: "#f8f9fa", cursor: "not-allowed" } : {}}
                {...register(`email`, {
                  required: true,
                  pattern: /^\S+@\S+$/i,
                })}
              />
              {errors.email && (
                <div className="error-message">
                  {"Please enter valid email"}
                </div>
              )}
              {props.data?._id && (
                <div className="text-end mt-1">
                  <a
                    href="#"
                    className="text-decoration-underline"
                    style={{ whiteSpace: "nowrap", fontSize: "0.85rem" }}
                    onClick={(e) => {
                      e.preventDefault();
                      openPasswordBlade();
                    }}
                    data-user-id={props.data?._id}
                  >
                    Change Password
                  </a>
                </div>
              )}
            </div>
            {!props.data?._id && (
              <>
                <Form.Label className="label">
                  Password <span className="text-danger">*</span>
                </Form.Label>
                <div className="input-group border rounded" style={{ flexWrap: "nowrap" }}>
                  <span className="input-group-text bg-white border-0 text-secondary">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4l-2.3-2.3a1 1 0 0 0-1.4 0l-2.1 2.1a1 1 0 0 0 0 1.4Z" />
                      <path d="m21 2-9.6 9.6" />
                      <circle cx="7.5" cy="15.5" r="5.5" />
                    </svg>
                  </span>
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control ps-0 pe-2 border-0 shadow-none mb-0"
                    placeholder="Enter Password"
                    {...register("password", {
                      required: "Please enter password",
                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters",
                      },
                      pattern: {
                        value:
                          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
                        message:
                          "Password must contain one Uppercase letter, one Number, and one Special character",
                      },
                    })}
                    style={{ height: "35px" }}
                  />
                  <span
                    className="input-group-text text-secondary bg-white border-0 cursor-pointer"
                    onClick={() => setShowNewPassword((prev) => !prev)}
                  >
                    {showNewPassword ? (
                      <EyeSlashFill size={16} />
                    ) : (
                      <EyeFill size={16} />
                    )}
                  </span>
                </div>
                {errors.password && (
                  <div className="error-message">{errors.password.message}</div>
                )}
                {/* Confirm Password */}
                <div className="form-group mt-2 mb-2">
                  <Form.Label className="label">
                    Confirm Password <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="input-group border rounded " style={{ flexWrap: "nowrap" }}>
                    <span className="input-group-text bg-white border-0 text-secondary">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4l-2.3-2.3a1 1 0 0 0-1.4 0l-2.1 2.1a1 1 0 0 0 0 1.4Z" />
                        <path d="m21 2-9.6 9.6" />
                        <circle cx="7.5" cy="15.5" r="5.5" />
                      </svg>
                    </span>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control ps-0 pe-2 border-0 shadow-none mb-0"
                      placeholder="Confirm Password"
                      {...register("confirmPassword", {
                        required: "Enter confirm password",
                        validate: (val) =>
                          val === watch("password") || "Passwords do not match",
                      })}
                      style={{ height: "35px" }}
                    />
                    <span className="input-group-text text-secondary bg-white border-0 cursor-pointer"
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    >
                      {showConfirmPassword ? (
                        <EyeSlashFill size={16} />
                      ) : (
                        <EyeFill size={16} />
                      )}
                    </span>
                  </div>
                  {errors.confirmPassword && (
                    <div className="error-message">
                      {errors.confirmPassword.message}
                    </div>
                  )}
                </div>
              </>
            )}
            <Form.Group className="mb-2">
              <Form.Label className="label">Role <span className="text-danger">*</span></Form.Label>
              <Form.Select {...register("role", { required: "Please select a role" })}>
                <option value="">
                  Select Role
                </option>
                {roles.map((role: any) => (
                  <option key={role._id} value={role._id}>
                    {role.roleName}
                  </option>
                ))}
              </Form.Select>
              {(errors as any).role && (
                <div className="error-message">{(errors as any).role.message}</div>
              )}
            </Form.Group>
            <div className="d-flex justify-content-end p-3">
              <CustomButton
                isLoading={isLoading}
                label="Save"
                className="w-100"
                type="submit"
                id="saveUserButton"
              />
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
      {isPasswordBladeOpen && (
        <ChangePasswordBlade
          isShow={isPasswordBladeOpen}
          isClose={() => setPasswordBladeOpen(false)}
          user={selectedUser}
        />
      )}
    </>
  );
};

export default AddAdminUser;
